module.exports = __webpack_public_path__ + "img/60.ac01fcc5.png";